export default __webpack_public_path__ + "static/media/left_middle.95ac98f2.png";